export function SlimeVRIcon({ drag }: { drag?: boolean }) {
  return (
    <svg
      width="49"
      height="29"
      viewBox="0 0 49 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-tauri-drag-region={drag}
    >
      <path
        d="M2 26.996C10.44 25.59 29.16 23.1571 46.509 26.9091C46.509 26.9091 48.89 -0.199966 35.761 2.14503"
        stroke="#A44FED"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M7.52161 15.0107L12.3649 9.20459L17.5044 13.9572"
        stroke="#A44FED"
        strokeWidth="3.00157"
        strokeLinecap="round"
      />
      <path
        d="M27.9566 14.1435L33.7372 9.27062L37.9695 14.8458"
        stroke="#A44FED"
        strokeWidth="3.00136"
        strokeLinecap="round"
      />
    </svg>
  );
}
